import classNames from "classnames";
import { useAppLayoutStore } from "PFApp/stores/app_layout_store";
import { Inline } from "PFComponents/containers";
import { ReactNode } from "react";

import css from "./page_footer.module.scss";

type PageFooterProps = {
  children: ReactNode;
  className?: string;
};

export const PageFooter = ({ children, className }: PageFooterProps) => {
  const appLeftPadding = useAppLayoutStore((state) => state.mainLeft);
  const appRightPadding = useAppLayoutStore((state) => state.mainRight);
  const edgeToEdge = useAppLayoutStore((state) => state.edgeToEdge);

  return (
    <footer className={css.footer} style={{ paddingLeft: appLeftPadding, paddingRight: appRightPadding }}>
      <Inline
        gap="spacingLg"
        spread
        alignItems="center"
        className={classNames(css.footerContent, className, { [css.edgeToEdge]: edgeToEdge })}
      >
        {children}
      </Inline>
    </footer>
  );
};
